import {testIdProps} from '@github-ui/test-id-props'
import {clsx} from 'clsx'

import {SanitizedHtml} from '../../dom/sanitized-html'
import styles from './sanitized-group-header-text.module.css'

export function SanitizedGroupHeaderText({titleHtml, className}: {titleHtml: string; className?: string}) {
  return (
    <SanitizedHtml className={clsx(styles.SanitizedHtml, className)} {...testIdProps(`group-name`)}>
      {titleHtml}
    </SanitizedHtml>
  )
}

try{ SanitizedGroupHeaderText.displayName ||= 'SanitizedGroupHeaderText' } catch {}